import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

const AutoStaticBadge = () => {
  return <AutoStaticBadgeWrapper>Auto</AutoStaticBadgeWrapper>;
};

export default AutoStaticBadge;

const AutoStaticBadgeWrapper = styled.div`
  height: 24px;
  width: 56px;
  padding: 3px 6px;
  border-radius: 20px;
  background: ${colors.primaryLightHover};
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  color: ${colors.primaryDark};
  text-align: center;
  margin-left: 8px;
`;
